import { useContext } from 'react';

import { HoneycombDataContext } from '../context/honeycomb-data.context.js';

export const useHoneycombData = () => {
  return useContext(HoneycombDataContext);
};
